export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            漫画投稿、合作洽谈、问题反馈，欢迎随时与我们取得联系
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-100">
                  <i className="ri-mail-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-950 mb-1">漫画投稿</h3>
                <p className="text-xs text-foreground-500">submit@gugumanga.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-100">
                  <i className="ri-team-line text-xl text-accent-500"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-950 mb-1">商务合作</h3>
                <p className="text-xs text-foreground-500">biz@gugumanga.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-secondary-100">
                  <i className="ri-question-answer-line text-xl text-secondary-500"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-950 mb-1">问题反馈</h3>
                <p className="text-xs text-foreground-500">support@gugumanga.com</p>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-background-200/60 text-center">
              <p className="text-sm text-foreground-500 mb-2">或通过社交媒体找到我们</p>
              <div className="flex items-center justify-center gap-3">
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline">
                  <i className="ri-tiktok-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}